exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leftInput[data-v-5da65559] {\n  width: 80%;\n}\n.my-box .my-card[data-v-5da65559] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-5da65559] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-5da65559]:last-child {\n    margin-bottom: 0;\n}\n.my-box .grid-content[data-v-5da65559] {\n  border-radius: 4px;\n  height: 36px;\n  white-space: nowrap;\n}\n.my-box .grid-content .el-input__inner[data-v-5da65559] {\n    max-width: 190px;\n}\n.my-box .grid-content span[data-v-5da65559] {\n    font-size: 14px;\n}\n", ""]);

// exports
